import { regexPattern } from 'src/app/shared/constants/regexPattern';
import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validateAddress, validateCity, validateName, validateZipCode } from 'src/app/shared/validators/validator';

export const AddNewStudentFormModel: ISedmsFormModel = {
    lastName: {
        name: 'lastName',
        required: true,
        validators: [{ validator: validateName(true) }]
    },
    firstName: {
        name: 'firstName',
        required: true,
        validators: [{ validator: validateName(true) }]
    },
    middleName: {
        name: 'middleName',
        required: false,
        pattern: regexPattern.name
    },
    gender: {
        name: 'gender',
        required: true,
    },
    dob: {
        name: 'dob',
        required: true,
    },
    apartmentNumber: {
        name: 'apartmentNumber',
        required: false,
    },
    homeBorough: {
        name: 'homeBorough',
        required: true,
    },
    streetName: {
        name: 'streetName',
        required: true,
        validators: [{ validator: validateAddress(true) }]
    },
    city: {
        name: 'city',
        required: true,
        validators: [{ validator: validateCity(true) }]
    },
    state: {
        name: 'state',
        required: true,
    },
    zip: {
        name: 'zip',
        required: true,
        validators: [{ validator: validateZipCode(true) }]
    },
    guardianRelationship: {
        name: 'guardianRelationship',
        required: true,
    },
    guardianFirstName: {
        name: 'guardianFirstName',
        required: true,
        validators: [{ validator: validateName(true) }]
    },
    guardianLastName: {
        name: 'guardianLastName',
        required: true,
        validators: [{ validator: validateName(true) }]
    },
    schoolDistrict: {
        name: 'schoolDistrict',
        required: true,
    },
    studentSk: {
        name: 'studentSk'
    }
};